import React from "react";
import { Link } from "react-router-dom";
import SiteReviews from "../components/SiteReviews";
import "./ThankYouPage.css";

const ThankYouPage = () => {
  return (
    <div className="thankyou-page">
      {/* TOP SECTION */}
      <div className="blue-section">
        <div className="thankyou-card text-center">
          <h1 className="fw-bold">Thank you!</h1>
          <p className="mt-3">
            We’ve received your query and our team will get in touch with you shortly.{" "}
            <strong>
              If you’d like to connect right away, just drop us a message on WhatsApp — we’ll assist you as soon as possible!
            </strong>
          </p>

          <div className="button-group mt-4">
            <Link to="/" className="btn btn-success px-4 py-2 rounded-pill">
              GO TO THE WEBSITE
            </Link>

            <a
              href="https://wa.me/9888823721"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-light px-4 py-2 rounded-pill ms-3"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>

      {/* REVIEWS SECTION */}
      <div className="review-section">
        <SiteReviews limit={3} showButton={true} variant="grid" hideHeading={false}   customHeading="Checkout Our Reviews" // ✅ Custom heading for Thank You page
/>
      </div>
    </div>
  );
};

export default ThankYouPage;
